import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FlowType = 'registration' | 'login' | 'migrate';

export interface FlowContextState {
  currentFlow: FlowType | null;
  redirectAfterPin: string | null;
}

const initialState: FlowContextState = {
  currentFlow: null,
  redirectAfterPin: null,
};

const flowContextSlice = createSlice({
  name: 'flowContext',
  initialState,
  reducers: {
    setFlowContext(state, action: PayloadAction<{ flow: FlowType; redirectAfterPin: string }>) {
      state.currentFlow = action.payload.flow;
      state.redirectAfterPin = action.payload.redirectAfterPin;
    },
    clearFlowContext(state) {
      state.currentFlow = null;
      state.redirectAfterPin = null;
    },
    setRedirectAfterPin(state, action: PayloadAction<string>) {
      state.redirectAfterPin = action.payload;
    },
  },
});

// Reducer
export default flowContextSlice.reducer;

// Actions
export const { setFlowContext, clearFlowContext, setRedirectAfterPin } = flowContextSlice.actions;